import { useCallback, useEffect, useState } from 'react';
import { usePusherBusinessChannel } from './PusherBusinessChannelProvider';
export function useBusinessChannelEventBinder(eventName, source) {
    const { getChannel, channelBusinessId } = usePusherBusinessChannel();
    const [listeners, setListeners] = useState([]);
    const startListening = useCallback(function(callback) {
        let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        setListeners((prevListeners)=>[
                ...prevListeners,
                {
                    callback,
                    options,
                    isListening: false
                }
            ]);
    }, []);
    useEffect(()=>{
        if (channelBusinessId && listeners.some((l)=>!l.isListening)) {
            listeners.filter((l)=>!l.isListening).forEach((listener)=>{
                var _getChannel, _listener_options_onBind, _listener_options;
                (_getChannel = getChannel(source)) === null || _getChannel === void 0 ? void 0 : _getChannel.bind(eventName, listener.callback);
                (_listener_options_onBind = (_listener_options = listener.options).onBind) === null || _listener_options_onBind === void 0 ? void 0 : _listener_options_onBind.call(_listener_options);
                listener.isListening = true;
            });
        }
    }, [
        channelBusinessId,
        eventName,
        listeners,
        source
    ]);
    useEffect(()=>{
        return ()=>{
            var _getChannel;
            (_getChannel = getChannel(source)) === null || _getChannel === void 0 ? void 0 : _getChannel.unbind(eventName);
        };
    }, [
        eventName,
        channelBusinessId,
        source
    ]);
    return {
        startListening,
        unbind: ()=>{
            var _getChannel;
            (_getChannel = getChannel(source)) === null || _getChannel === void 0 ? void 0 : _getChannel.unbind(eventName);
        }
    };
}
